import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconUndo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconUndo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5309261fee83ab5507c1cd0022e494a0f45e5804', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ab8cf159f86339771f8cd7738d30cc9dc90996af', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e20a6db4d23f63119a2d01496d0b2992fd5249f0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.634 7.472H8.006V5.2a.5.5 0 0 0-.853-.354L4.12 7.87a.5.5 0 0 0 0 .706l3.032 3.052a.5.5 0 0 0 .854-.352v-2.3h4.628a3.6 3.6 0 0 1 3.662 3.358 3.32 3.32 0 0 1-.939 2.473 3.7 3.7 0 0 1-1.926 1.015.51.51 0 0 0-.425.493v.532a.51.51 0 0 0 .587.5 5 5 0 0 0 2.841-1.493 4.85 4.85 0 0 0 1.362-3.565 5.11 5.11 0 0 0-5.162-4.817", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-undo", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-undo"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-undo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconUndo$1);
            }
            break;
    } });
}

const CosmosIconUndo = CosmosIconUndo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconUndo, defineCustomElement };
